<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.mode !== FormMode.Creation) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Id</mat-label>
                        <input matInput [formControl]="idFormControl" [(ngModel)]="data.record.id" autocomplete="off" />
                    </mat-form-field>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Ce paramètre permet de specifier le processus de type 'Identification de type de document' qui sera executé à la reception d'un e-mail sur ce canal."
                        tooltipPosition="right"></fa-icon>
                </div>
            }
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Processus</mat-label>
                    <mat-select [formControl]="processDefinitionFormControl" [(ngModel)]="data.record.processDefinitionId" required>
                        @for (processDefinition of processDefinitions; track processDefinition) {
                            <mat-option [value]="processDefinition.id">{{ processDefinition.name }}</mat-option>
                        }
                    </mat-select>
                    @if (processDefinitionFormControl?.errors?.required && (processDefinitionFormControl?.dirty || processDefinitionFormControl.touched)) {
                        <mat-error>Le champ 'Processus' est obligatoire.</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce paramètre permet de specifier le processus de type 'Identification de type de document' qui sera executé à la reception d'un e-mail sur ce canal."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Client</mat-label>
                    <mat-select [formControl]="customerFormControl" [(ngModel)]="data.record.customerId">
                        @for (customer of customers; track customer) {
                            <mat-option [value]="customer.id">{{ customer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si ce paramètre est spécifié, il permet de limiter l'execution de ce processus aux e-mails reçus pour lesquels le client identifié correspond à ce paramètre."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Type de document</mat-label>
                    <mat-select [formControl]="documentTypeFormControl" [(ngModel)]="data.record.documentTypeId">
                        @for (documentType of documentTypes; track documentType) {
                            <mat-option [value]="documentType.id">{{ documentType.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si ce paramètre est spécifié, il permet de limiter l'execution de ce processus aux e-mails reçus pour lesquels le type de document identifié correspond à ce paramètre."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Emetteur</mat-label>
                    <input matInput [formControl]="issuerFormControl" [(ngModel)]="data.record.issuer" autocomplete="off" />
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si ce paramètre est spécifié, il permet de limiter l'execution de ce processus aux e-mails reçus pour lesquels l'emetteur correspond à ce paramètre."
                    tooltipPosition="right"></fa-icon>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [ngClass]="{ hidden: data.mode === FormMode.Reading }" (click)="cancel()">Annuler</button>
        @if (data.mode !== FormMode.Reading) {
            <button mat-raised-button class="accent-button" [mat-dialog-close]="data.record" [disabled]="!isValid">Enregistrer</button>
        } @else {
            <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
        }
    </mat-card-actions>
</mat-card>
